"use client";
import { useState } from "react";
import { authenticateWithPhone } from "@/services/authService";
import { clientLogger } from "@/utils/clientLogger";
import { useMnoContext } from "@/context/MnoContext";

export function useAuthentication() {
  const { config } = useMnoContext();
  const [statusMessage, setStatusMessage] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const [requestId, setRequestId] = useState<string | null>(null);

  const handleAuthentication = async (
    phoneNumber: string
  ) => {
    setIsLoading(true);
    setStatusMessage("");
    setSuccess(false);
    try {
      const data = await authenticateWithPhone(
        config.countryCode + phoneNumber,
        config.id
      );
      if (!data.success) {
        if (data.message) {
          setStatusMessage(data.message);
        } else {
          setStatusMessage("Unable to initiate mobile number verification.");
        }
        setSuccess(false);
      } else {
        setSuccess(true);
        setRequestId(data.requestId);
      }
    } catch (err: unknown) {
      clientLogger.error(
        "Something went wrong. Please try again later or contact support.",
        { error: err }
      );
      setStatusMessage(
        "Something went wrong. Please try again later or contact support."
      );
      setSuccess(false);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    handleAuthentication,
    success,
    statusMessage,
    setStatusMessage,
    isLoading,
    requestId,
  };
}
